import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Yaragh extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getAllYaragh(params) {
    return this.httpService.get("Definition/all-brand-fitting", {
      headers,
      params,
    });
  }

  getAllBrandYaragh(params) {
    return this.httpService.get("Definition/all-brand-fitting-country-struct", {
      headers,
      params,
    });
  }

  getAllYaraghCountry(params) {
    return this.httpService.get("Definition/all-country-fitting", {
      headers,
      params,
    });
  }

  getAllBazsho(params) {
    return this.httpService.get("Definition/all-pop-with-brand", {
      headers,
      params,
    });
  }

  getMahdoode(params) {
    return this.httpService.get("Definition/all-range-commercial", {
      headers,
      params,
    });
  }

  getHalat(params) {
    return this.httpService.get("Definition/stype-pop-fitting", {
      headers,
      params,
    });
  }

  addyaragh(data) {
    return this.httpService.post("Definition/add-fitting-manual", data, {
      headers,
    });
  }

  addBazsho(data) {
    return this.httpService.post("Definition/insert-pop", data, { headers });
  }

  InsertAutoBrandYaragh(data) {
    return this.httpService.post("Definition/add-fitting-auto", data, {
      headers,
    });
  }

  UpdateBrandName(data) {
    return this.httpService.put("Definition/update-brand-fitting", data, {
      headers,
    });
  }

  DeleteBrand(data) {
    return this.httpService.delete("Definition/delete-brand-fitting", {
      headers,
      data,
    });
  }

  getRelationBrand(params) {
    return this.httpService.get("Definition/relation-brand-fitting", {
      headers,
      params,
    });
  }

  updatePriceBrandGroup(data) {
    return this.httpService.put(
      "Definition/price-range-commercial-group",
      data,
      { headers }
    );
  }

  disableYaragh(data) {
    return this.httpService.put("Definition/disable-brand-fitting", data, {
      headers,
    });
  }

  DeleteBazsho(data) {
    return this.httpService.delete("Definition/delete-pop-design", {
      headers,
      data,
    });
  }

  getRelationBazsho(params) {
    return this.httpService.get("Definition/relation-pop-design", {
      headers,
      params,
    });
  }

  editBazshoName(data) {
    return this.httpService.put("Definition/update-pop", data, { headers });
  }

  DeleteMahdoode(data) {
    return this.httpService.delete("Definition/delete-range-commercial", {
      headers,
      data,
    });
  }

  updateMahdoode(data) {
    return this.httpService.put("Definition/update-range-commercial", data, {
      headers,
    });
  }

  addMahdoode(data) {
    return this.httpService.post("Definition/insert-range-commercial", data, {
      headers,
    });
  }

  UpdatePriceMahdoode(data) {
    return this.httpService.put("Definition/price-range-commercial", data, {
      headers,
    });
  }

  getMahdoodeFani(params) {
    return this.httpService.get("Definition/range-technical", {
      headers,
      params,
    });
  }

  addMahdoodeFani(data) {
    return this.httpService.post("Definition/range-technical", data, {
      headers,
    });
  }

  updateMahdoodeFani(data) {
    return this.httpService.put("Definition/range-technical", data, {
      headers,
    });
  }

  deleteMahdoodeFani(data) {
    return this.httpService.delete("Definition/range-technical", {
      headers,
      data,
    });
  }

  getPartLocal(params) {
    return this.httpService.get("Definition/part-local", {
      headers,
      params,
    });
  }

  addPartLocal(data) {
    return this.httpService.post("Definition/part-local", data, {
      headers,
    });
  }

  updatePartLocal(data) {
    return this.httpService.put("Definition/part-local", data, {
      headers,
    });
  }

  deletePartLocal(data) {
    return this.httpService.delete("Definition/part-local", {
      headers,
      data,
    });
  }

  copyPartLocal(data) {
    return this.httpService.post("Definition/part-local/copyto", data, {
      headers,
    });
  }

  getStuffFitting(params) {
    return this.httpService.get("Definition/stuff-fitting", {
      headers,
      params,
    });
  }

  getStuffFittingCombo(params) {
    return this.httpService.get("Definition/stuff-fitting/combo", {
      headers,
      params,
    });
  }

  addStuffFitting(data) {
    return this.httpService.post("Definition/stuff-fitting", data, {
      headers,
    });
  }

  updateStuffFitting(data) {
    return this.httpService.put("Definition/stuff-fitting", data, {
      headers,
    });
  }

  deleteStuffFitting(data) {
    return this.httpService.delete("Definition/stuff-fitting", {
      headers,
      data,
    });
  }

  getAxFitting(params) {
    return this.httpService.get("Definition/ax-fitting", {
      headers,
      params,
    });
  }

  getDirectionFitting(params) {
    return this.httpService.get("Definition/direction-fitting", {
      headers,
      params,
    });
  }

  getColorFitting(params) {
    return this.httpService.get("Definition/color-fitting", {
      headers,
      params,
    });
  }

}

const YaraghService = new Yaragh();
export default YaraghService;
